import classNames from "classnames";
import React, { type CSSProperties } from "react";
import "./Divider.css";

type DividerVariant = "solid" | "dotted";

type MarginProp = {
    top?: number | undefined;
    bottom?: number | undefined;
    left?: number | undefined;
    right?: number | undefined;
};

function composeMarginStyle(margin?: MarginProp): CSSProperties | undefined {
    if (!margin)
        return {
            margin: `0 0 0 0`,
        };
    return {
        margin: `${margin.top || 0}px ${margin.right || 0}px ${
            margin.bottom || 0
        }px ${margin.left || 0}px`,
    };
}

type Prop = {
    axis?: "horizontal" | "vertical";
    margin?: MarginProp;
    className?: string;
    variant?: DividerVariant | undefined;
};

function Divider({ axis, className, variant, margin }: Prop) {
    return (
        <div
            style={composeMarginStyle(margin)}
            className={classNames(className, {
                [`component-divider-${axis}__dotted`]: variant && variant === "dotted",
                [`component-divider-${axis}__solid`]: variant && variant === "solid",
            })}
        />
    );
}

export default Divider;
